import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_APPOINTMENTS } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: POST /api/v1/consultation/doctor/consultation-fees
//
// This thunk owns the user-facing toast for a fee submission — callers must not
// raise their own, or the doctor sees two notifications per submission.
export const updateConsultationFeeReducer = createAsyncThunk(
  ACTION_DOCTOR_APPOINTMENTS.update_consultation_fee,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.createUpdateConsultationFee}`,
        payload,
      );

      if (response?.data?.status === true) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);
        return response.data.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(message);
      }
    } catch (error) {
      console.error("Error updating consultation fee:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
